import { Route, Routes } from 'react-router-dom';
import AnagraphicPage from './components/pages/anagraphic/anagraphic';
import Login from './components/pages/auth/login';
import Commissions from './components/pages/commissions/commissions';
import { CommissionDetail } from './components/pages/commissions/detail/commissionDetail';
import { EmployeeDetails } from './components/pages/employees/employeeDetails';
import Employees from './components/pages/employees/employees';
import Homepage from './components/pages/homepage/homepage';
import PageNotFound from './components/pages/not-found/404';
import { PrivateRoute } from './components/pages/private-route/private-route';
import ProfilesAndAuthorizations from './components/pages/profiles-and-authorizations/profiles-and-authorizations';
import { ChangePassword } from './components/pages/settings/changePassword';
import Timesheets from './components/pages/timesheets/timesheets';
import UserTimesheets from './components/pages/timesheets/userTimesheets';
import { ResetPassword } from './components/pages/settings/resetPassword';
import {
  EDIT_ACCOUNT_PERMISSION,
  EDIT_ANAGRAPHIC_PERMISSION,
  EDIT_COMMISSION_PERMISSION,
  EDIT_TIMESHEET_PERMISSION,
  VIEW_ANAGRAPHIC_PERMISSION,
  VIEW_CAPABILITIES_PERMISSION,
  VIEW_COMMISSION_PERMISSION,
  VIEW_TIMESHEETS_PERMISSION,
} from './utils/capability-utils';

const RootRoutes = () => {
  return (
    <Routes>
      <Route path="/">
        <Route path="/" element={<Homepage />} />
      </Route>

      <Route path="/login">
        <Route path="/login" element={<Login />} />
      </Route>

      <Route path="/employees" element={<PrivateRoute capabilities={[VIEW_ANAGRAPHIC_PERMISSION]} />}>
        <Route path="/employees" element={<Employees />} />
      </Route>

      <Route path="/employee/:id" element={<PrivateRoute capabilities={[EDIT_ANAGRAPHIC_PERMISSION]} />}>
        <Route path="/employee/:id" element={<EmployeeDetails />} />
      </Route>

      <Route path="/anagraphic/:id" element={<PrivateRoute capabilities={[EDIT_ACCOUNT_PERMISSION]} />}>
        <Route path="/anagraphic/:id" element={<AnagraphicPage />} />
      </Route>

      <Route path="/commissions" element={<PrivateRoute capabilities={[VIEW_COMMISSION_PERMISSION]} />}>
        <Route path="/commissions" element={<Commissions />} />
      </Route>

      <Route path="/commissions/:id" element={<PrivateRoute capabilities={[EDIT_COMMISSION_PERMISSION]} />}>
        <Route path="/commissions/:id" element={<CommissionDetail />} />
      </Route>

      <Route path="/profiles" element={<PrivateRoute capabilities={[VIEW_CAPABILITIES_PERMISSION]} />}>
        <Route path="/profiles" element={<ProfilesAndAuthorizations />} />
      </Route>

      <Route path="/timesheets" element={<PrivateRoute capabilities={[VIEW_TIMESHEETS_PERMISSION]} />}>
        <Route path="/timesheets" element={<Timesheets />} />
      </Route>

      <Route path="/timesheets/:id" element={<PrivateRoute capabilities={[EDIT_TIMESHEET_PERMISSION]} />}>
        <Route path="/timesheets/:id" element={<UserTimesheets />} />
      </Route>

      <Route path="/timesheet/:id" element={<PrivateRoute capabilities={[EDIT_TIMESHEET_PERMISSION]} />}>
        <Route path="/timesheet/:id" element={<UserTimesheets />} />
      </Route>

      <Route path="/reset-password/:personalCode">
        <Route path="/reset-password/:personalCode" element={<ResetPassword />} />
      </Route>

      <Route path="/change-password/:id">
        <Route path="/change-password/:id" element={<ChangePassword />} />
      </Route>

      <Route path="*">
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default RootRoutes;
